/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_location_control__tooltip__header = /** @type {(inputs: {}) => string} */ () => {
	return `Die Standortermittlung ist deaktiviert`
};

const en_location_control__tooltip__header = /** @type {(inputs: {}) => string} */ () => {
	return `Your location is disabled`
};

const es_location_control__tooltip__header = /** @type {(inputs: {}) => string} */ () => {
	return `Tu ubicación está desactivada`
};

const fr_location_control__tooltip__header = /** @type {(inputs: {}) => string} */ () => {
	return `Votre localisation est désactivée`
};

const it_location_control__tooltip__header = /** @type {(inputs: {}) => string} */ () => {
	return `La localizzazione è disattivata`
};

const nl_location_control__tooltip__header = /** @type {(inputs: {}) => string} */ () => {
	return `Uw locatie is gedeactiveerd`
};

const pt_location_control__tooltip__header = /** @type {(inputs: {}) => string} */ () => {
	return `A sua localização está desativada`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__header = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.location_control__tooltip__header(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("location_control__tooltip__header", locale)
	if (locale === "de") return de_location_control__tooltip__header(inputs)
	if (locale === "en") return en_location_control__tooltip__header(inputs)
	if (locale === "es") return es_location_control__tooltip__header(inputs)
	if (locale === "fr") return fr_location_control__tooltip__header(inputs)
	if (locale === "it") return it_location_control__tooltip__header(inputs)
	if (locale === "nl") return nl_location_control__tooltip__header(inputs)
	return pt_location_control__tooltip__header(inputs)
};